import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  GeneralComplianceResponse,
  RTOComplianceResponse,
} from '@interfaces/quarterly-feedback.model';
import { environment } from '@environments/environment';
import { catchError, Observable } from 'rxjs';
import { ToasterService } from './toaster.service';

@Injectable({
  providedIn: 'root',
})
export class QuarterlyFeedbackComplianceService {
  private baseUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private toasterService: ToasterService
  ) {}

  getGeneralCompliance(
    year: string,
    vendorId: number,
    quarter: string,
  ): Observable<{ data: GeneralComplianceResponse[] }> {
    const url = `${this.baseUrl}/hiring/general-compliance?year=${year}&vendorId=${vendorId}&quarter=${quarter}`;
    return this.http.get<{ data: GeneralComplianceResponse[] }>(url).pipe(
      catchError((error) => {
        this.toasterService.showError('Failed to fetch general compliance data.', 'Error');
        throw error;
      }),
    );
  }

  getRtoCompliance(
    vendorId: string,
    employeeId: string,
  ): Observable<{ data: RTOComplianceResponse }> {
    let url = `${this.baseUrl}/hiring/employee-attendance?vendorId=${vendorId}`;
    if (employeeId !== '') {
      url += `&employeeId=${employeeId}`;
    }
    return this.http.get<{ data: RTOComplianceResponse }>(url).pipe(
      catchError((error) => {
        this.toasterService.showError('Failed to fetch RTO compliance data.', 'Error');
        throw error;
      }),
    );
  }
}
